import { render } from "./soldierlists.vue?vue&type=template&id=516f45e9"
import script from "./soldierlists.vue?vue&type=script&lang=js"
export * from "./soldierlists.vue?vue&type=script&lang=js"

import "./soldierlists.vue?vue&type=style&index=0&id=516f45e9&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__